// Landing Page translations
export const landingT = {
  en: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "The Sideline Has",
    heroTitle2: "a New Standard.",
    heroDesc: 'Meet "The Gaffer" – The world\'s first premium football boot engineered specifically for the coach. Comfort, warmth, and authority in every step.',
    heroCta: "Join the Waitlist",
    blog: "Blog",
    // Problem Section
    problemLabel: "The Problem",
    problemTitle: "The Forgotten Leader.",
    problemP1: "Every piece of kit on a football pitch is designed for the player. The boots. The shin pads. The base layers. All engineered around the demands of someone covering 10km a game.",
    problemP2: "The coach? Standing still. In the rain. For 90 minutes. In footwear that was never built for the sideline.",
    problemP3: 'It\'s time someone remembered the coach. That someone is us. Welcome to "The Gaffer."',
    // Solution Section
    solutionLabel: "The Solution",
    solutionTitle: "The Material Sandwich.",
    solutionDesc: 'Every layer of "The Gaffer" serves a purpose. Nothing decorative. Nothing wasted.',
    feat1Title: "Calf-Leather",
    feat1Desc: "Premium calfskin that moulds to your foot over time. Ages beautifully. Built to last seasons, not matches.",
    feat2Title: "TEX-Membrane",
    feat2Desc: "Water-repellent. No more wet feet, even in the heaviest downpour.",
    feat3Title: "Warm Lining",
    feat3Desc: "Thermal regulation and anti-bacterial comfort. Warm in winter, cool in summer.",
    feat4Title: "Ergonomic Sole",
    feat4Desc: "Optimised heel-to-toe drop for standing, not sprinting. All-day comfort on the touchline.",
    // Quality Section
    qualityLabel: "Quality & Provenance",
    qualityTitle: "Handcrafted in Portugal.",
    qualityP1: '"The Gaffer" is assembled by hand in a family-run factory in northern Portugal — a region with over a century of shoemaking heritage.',
    qualityP2: "Every pair is cut, stitched, and finished by artisans who understand that a great boot isn't manufactured — it's made.",
    qualityBadge: "Handcrafted in Portugal",
    // Footer / Waitlist
    footerTitle: "Don't Miss the Kick-off.",
    footerDesc: "Sign up to be the first to know when we start the prepaid softlaunch this fall. Limited early-bird slots available.",
    footerFname: "First Name",
    footerEmail: "Email Address *",
    footerCta: "Secure My Pair",
    footerSubmitting: "Signing up...",
    footerSuccessTitle: "You're on the list!",
    footerSuccessDesc: "We'll notify you when we launch. Check your inbox for a confirmation.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Denmark · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "Terms & Conditions", privacy: "Privacy Policy", accessibility: "Accessibility", complaints: "Complaints", withdrawal: "Withdrawal Form" },
  },
  da: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "Sidelinjen har",
    heroTitle2: "en ny standard.",
    heroDesc: 'Mød "The Gaffer" – Verdens første premium fodboldstøvle designet specifikt til træneren. Komfort, varme og autoritet i hvert skridt.',
    heroCta: "Tilmeld ventelisten",
    blog: "Blog",
    problemLabel: "Problemet",
    problemTitle: "Den glemte leder.",
    problemP1: "Alt udstyr på en fodboldbane er designet til spilleren. Støvlerne. Benskinnnerne. Baselayers. Alt udviklet til en der løber 10 km per kamp.",
    problemP2: "Træneren? Står stille. I regnen. I 90 minutter. I fodtøj der aldrig blev bygget til sidelinjen.",
    problemP3: 'Det er på tide nogen husker træneren. Det er os. Velkommen til "The Gaffer."',
    solutionLabel: "Løsningen",
    solutionTitle: "Materiale-sandwichen.",
    solutionDesc: 'Hvert lag i "The Gaffer" tjener et formål. Intet dekorativt. Intet spildt.',
    feat1Title: "Kalvelæder",
    feat1Desc: "Premium kalveskind der former sig efter din fod over tid. Ældes smukt. Bygget til at holde sæsoner, ikke kampe.",
    feat2Title: "TEX-Membran",
    feat2Desc: "Vandafvisende. Ingen flere våde fødder, selv i det kraftigste regnvejr.",
    feat3Title: "Warm Lining",
    feat3Desc: "Termisk regulering og antibakteriel komfort. Varm om vinteren, kølig om sommeren.",
    feat4Title: "Ergonomisk sål",
    feat4Desc: "Optimeret hæl-til-tå drop til at stå, ikke spurte. Komfort hele dagen på sidelinjen.",
    qualityLabel: "Kvalitet & oprindelse",
    qualityTitle: "Håndlavet i Portugal.",
    qualityP1: '"The Gaffer" samles i hånden på en familiedrevet fabrik i det nordlige Portugal — en region med over hundrede års skomagertradition.',
    qualityP2: "Hvert par klippes, sys og færdiggøres af håndværkere der forstår, at en god støvle ikke fremstilles — den skabes.",
    qualityBadge: "Håndlavet i Portugal",
    footerTitle: "Gå ikke glip af kickoff.",
    footerDesc: "Tilmeld dig og vær den første til at vide, når vi starter det forudbetalte softlaunch til efteråret. Begrænset antal early-bird pladser.",
    footerFname: "Fornavn",
    footerEmail: "Email adresse *",
    footerCta: "Sikre mit par",
    footerSubmitting: "Tilmelder...",
    footerSuccessTitle: "Du er på listen!",
    footerSuccessDesc: "Vi giver dig besked når vi launcher. Tjek din indbakke for en bekræftelse.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Danmark · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "Handelsbetingelser", privacy: "Privatlivspolitik", accessibility: "Tilgængelighed", complaints: "Klager", withdrawal: "Fortrydelsesret" },
  },
  sv: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "Sidlinjen har",
    heroTitle2: "en ny standard.",
    heroDesc: 'Möt "The Gaffer" – Världens första premiumfotbollssko designad specifikt för tränaren. Komfort, värme och auktoritet i varje steg.',
    heroCta: "Gå med i väntelistan",
    blog: "Blogg",
    problemLabel: "Problemet",
    problemTitle: "Den bortglömda ledaren.",
    problemP1: "All utrustning på en fotbollsplan är designad för spelaren. Skorna. Benskydden. Baslagren. Allt utvecklat för någon som springer 10 km per match.",
    problemP2: "Tränaren? Står stilla. I regnet. I 90 minuter. I skor som aldrig byggdes för sidlinjen.",
    problemP3: 'Det är dags att någon minns tränaren. Det är vi. Välkommen till "The Gaffer."',
    solutionLabel: "Lösningen",
    solutionTitle: "Materialsmörgåsen.",
    solutionDesc: 'Varje lager i "The Gaffer" tjänar ett syfte. Inget dekorativt. Inget slösat.',
    feat1Title: "Kalvläder",
    feat1Desc: "Premiumkalvskinn som formar sig efter din fot med tiden. Åldras vackert. Byggd för att hålla säsonger, inte matcher.",
    feat2Title: "TEX-Membran",
    feat2Desc: "Vattenavvisande. Inga fler blöta fötter, även i det kraftigaste regnet.",
    feat3Title: "Warm Lining",
    feat3Desc: "Termisk reglering och antibakteriell komfort. Varm på vintern, sval på sommaren.",
    feat4Title: "Ergonomisk sula",
    feat4Desc: "Optimerat häl-till-tå-fall för att stå, inte sprinta. Komfort hela dagen vid sidlinjen.",
    qualityLabel: "Kvalitet & ursprung",
    qualityTitle: "Handgjord i Portugal.",
    qualityP1: '"The Gaffer" monteras för hand i en familjeägd fabrik i norra Portugal — en region med över hundra års skomakartradition.',
    qualityP2: "Varje par klipps, sys och färdigställs av hantverkare som förstår att en bra sko inte tillverkas — den skapas.",
    qualityBadge: "Handgjord i Portugal",
    footerTitle: "Missa inte avsparken.",
    footerDesc: "Anmäl dig för att vara först med att veta när vi startar den förbetalda softlanseringen i höst. Begränsat antal early-bird-platser.",
    footerFname: "Förnamn",
    footerEmail: "E-postadress *",
    footerCta: "Säkra mitt par",
    footerSubmitting: "Registrerar...",
    footerSuccessTitle: "Du är på listan!",
    footerSuccessDesc: "Vi meddelar dig när vi lanserar. Kolla din inkorg för en bekräftelse.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Danmark · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "Villkor", privacy: "Integritetspolicy", accessibility: "Tillgänglighet", complaints: "Klagomål", withdrawal: "Ångerrätt" },
  },
  no: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "Sidelinjen har",
    heroTitle2: "en ny standard.",
    heroDesc: 'Møt "The Gaffer" – Verdens første premium fotballstøvel designet spesifikt for treneren. Komfort, varme og autoritet i hvert steg.',
    heroCta: "Bli med på ventelisten",
    blog: "Blogg",
    problemLabel: "Problemet",
    problemTitle: "Den glemte lederen.",
    problemP1: "Alt utstyr på en fotballbane er designet for spilleren. Støvlene. Leggskinnene. Baselayerne. Alt utviklet for noen som løper 10 km per kamp.",
    problemP2: "Treneren? Står stille. I regnet. I 90 minutter. I fottøy som aldri ble bygget for sidelinjen.",
    problemP3: 'Det er på tide noen husker treneren. Det er oss. Velkommen til "The Gaffer."',
    solutionLabel: "Løsningen",
    solutionTitle: "Materialsandwichen.",
    solutionDesc: 'Hvert lag i "The Gaffer" tjener et formål. Ingenting dekorativt. Ingenting bortkastet.',
    feat1Title: "Kalveskinn",
    feat1Desc: "Premium kalveskinn som former seg etter foten din over tid. Eldes vakkert. Bygget for å vare sesonger, ikke kamper.",
    feat2Title: "TEX-Membran",
    feat2Desc: "Vannavvisende. Ingen flere våte føtter, selv i det kraftigste regnværet.",
    feat3Title: "Warm Lining",
    feat3Desc: "Termisk regulering og antibakteriell komfort. Varm om vinteren, kjølig om sommeren.",
    feat4Title: "Ergonomisk såle",
    feat4Desc: "Optimert hæl-til-tå-fall for å stå, ikke sprinte. Komfort hele dagen ved sidelinjen.",
    qualityLabel: "Kvalitet & opprinnelse",
    qualityTitle: "Håndlaget i Portugal.",
    qualityP1: '"The Gaffer" settes sammen for hånd i en familiedrevet fabrikk i Nord-Portugal — en region med over hundre års skomakertradisjon.',
    qualityP2: "Hvert par klippes, sys og ferdigstilles av håndverkere som forstår at en god støvel ikke produseres — den skapes.",
    qualityBadge: "Håndlaget i Portugal",
    footerTitle: "Ikke gå glipp av avsparket.",
    footerDesc: "Meld deg på for å være den første til å vite når vi starter den forhåndsbetalte softlanseringen til høsten. Begrenset antall early-bird-plasser.",
    footerFname: "Fornavn",
    footerEmail: "E-postadresse *",
    footerCta: "Sikre mitt par",
    footerSubmitting: "Registrerer...",
    footerSuccessTitle: "Du er på listen!",
    footerSuccessDesc: "Vi gir deg beskjed når vi lanserer. Sjekk innboksen din for en bekreftelse.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Danmark · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "Vilkår", privacy: "Personvern", accessibility: "Tilgjengelighet", complaints: "Klager", withdrawal: "Angrerett" },
  },
  de: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "Die Seitenlinie hat",
    heroTitle2: "einen neuen Standard.",
    heroDesc: 'Lernen Sie "The Gaffer" kennen – Den weltweit ersten Premium-Fußballschuh, der speziell für den Trainer entwickelt wurde. Komfort, Wärme und Autorität bei jedem Schritt.',
    heroCta: "Auf die Warteliste",
    blog: "Blog",
    problemLabel: "Das Problem",
    problemTitle: "Der vergessene Anführer.",
    problemP1: "Jedes Teil der Fußballausrüstung ist für den Spieler konzipiert. Die Schuhe. Die Schienbeinschoner. Die Baselayer. Alles für jemanden entwickelt, der 10 km pro Spiel läuft.",
    problemP2: "Der Trainer? Steht still. Im Regen. 90 Minuten lang. In Schuhen, die nie für die Seitenlinie gebaut wurden.",
    problemP3: 'Es ist Zeit, dass jemand an den Trainer denkt. Dieser Jemand sind wir. Willkommen bei "The Gaffer."',
    solutionLabel: "Die Lösung",
    solutionTitle: "Das Material-Sandwich.",
    solutionDesc: 'Jede Schicht von "The Gaffer" erfüllt einen Zweck. Nichts Dekoratives. Nichts Verschwendetes.',
    feat1Title: "Kalbsleder",
    feat1Desc: "Premium-Kalbsleder, das sich mit der Zeit an Ihren Fuß anpasst. Altert wunderschön. Gebaut für Saisons, nicht Spiele.",
    feat2Title: "TEX-Membran",
    feat2Desc: "Wasserabweisend. Keine nassen Füße mehr, selbst bei stärkstem Regen.",
    feat3Title: "Warm Lining",
    feat3Desc: "Thermische Regulierung und antibakterieller Komfort. Warm im Winter, kühl im Sommer.",
    feat4Title: "Ergonomische Sohle",
    feat4Desc: "Optimiertes Ferse-zu-Zehe-Gefälle zum Stehen, nicht zum Sprinten. Ganztägiger Komfort an der Seitenlinie.",
    qualityLabel: "Qualität & Herkunft",
    qualityTitle: "Handgefertigt in Portugal.",
    qualityP1: '"The Gaffer" wird von Hand in einer familiengeführten Fabrik in Nordportugal zusammengebaut — einer Region mit über hundert Jahren Schuhmachertradition.',
    qualityP2: "Jedes Paar wird von Handwerkern geschnitten, genäht und fertiggestellt, die verstehen, dass ein großartiger Schuh nicht hergestellt wird — er wird erschaffen.",
    qualityBadge: "Handgefertigt in Portugal",
    footerTitle: "Verpassen Sie nicht den Anstoß.",
    footerDesc: "Melden Sie sich an, um als Erster zu erfahren, wann wir den vorausbezahlten Softlaunch im Herbst starten. Begrenzte Early-Bird-Plätze.",
    footerFname: "Vorname",
    footerEmail: "E-Mail-Adresse *",
    footerCta: "Mein Paar sichern",
    footerSubmitting: "Anmeldung...",
    footerSuccessTitle: "Sie sind auf der Liste!",
    footerSuccessDesc: "Wir benachrichtigen Sie zum Launch. Prüfen Sie Ihren Posteingang für eine Bestätigung.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Dänemark · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "AGB", privacy: "Datenschutz", accessibility: "Barrierefreiheit", complaints: "Beschwerden", withdrawal: "Widerrufsrecht" },
  },
  fr: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "La ligne de touche a",
    heroTitle2: "un nouveau standard.",
    heroDesc: 'Découvrez "The Gaffer" – La première chaussure de football premium au monde conçue spécifiquement pour l\'entraîneur. Confort, chaleur et autorité à chaque pas.',
    heroCta: "Rejoindre la liste d'attente",
    blog: "Blog",
    problemLabel: "Le Problème",
    problemTitle: "Le leader oublié.",
    problemP1: "Chaque équipement sur un terrain de football est conçu pour le joueur. Les chaussures. Les protège-tibias. Les sous-couches. Tout est conçu pour quelqu'un qui court 10 km par match.",
    problemP2: "L'entraîneur ? Immobile. Sous la pluie. Pendant 90 minutes. Dans des chaussures qui n'ont jamais été conçues pour la ligne de touche.",
    problemP3: 'Il est temps que quelqu\'un pense à l\'entraîneur. Ce quelqu\'un, c\'est nous. Bienvenue chez "The Gaffer."',
    solutionLabel: "La Solution",
    solutionTitle: "Le sandwich de matériaux.",
    solutionDesc: 'Chaque couche de "The Gaffer" remplit une fonction. Rien de décoratif. Rien de gaspillé.',
    feat1Title: "Cuir de veau",
    feat1Desc: "Cuir de veau premium qui s'adapte à votre pied au fil du temps. Vieillit magnifiquement. Construit pour durer des saisons, pas des matchs.",
    feat2Title: "Membrane TEX",
    feat2Desc: "Déperlante. Plus de pieds mouillés, même sous les pluies les plus fortes.",
    feat3Title: "Warm Lining",
    feat3Desc: "Régulation thermique et confort antibactérien. Chaud en hiver, frais en été.",
    feat4Title: "Semelle ergonomique",
    feat4Desc: "Drop talon-orteil optimisé pour la station debout, pas le sprint. Confort toute la journée sur la ligne de touche.",
    qualityLabel: "Qualité & provenance",
    qualityTitle: "Fabriqué à la main au Portugal.",
    qualityP1: '"The Gaffer" est assemblé à la main dans une usine familiale du nord du Portugal — une région avec plus d\'un siècle de tradition de cordonnerie.',
    qualityP2: "Chaque paire est coupée, cousue et finie par des artisans qui comprennent qu'une grande chaussure n'est pas fabriquée — elle est créée.",
    qualityBadge: "Fabriqué à la main au Portugal",
    footerTitle: "Ne manquez pas le coup d'envoi.",
    footerDesc: "Inscrivez-vous pour être le premier informé du lancement du softlaunch prépayé cet automne. Places early-bird limitées.",
    footerFname: "Prénom",
    footerEmail: "Adresse email *",
    footerCta: "Réserver ma paire",
    footerSubmitting: "Inscription...",
    footerSuccessTitle: "Vous êtes sur la liste !",
    footerSuccessDesc: "Nous vous notifierons au lancement. Vérifiez votre boîte de réception pour une confirmation.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Danemark · CVR: 46469550",
    footerEmailAddr: "Email : contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "CGV", privacy: "Politique de confidentialité", accessibility: "Accessibilité", complaints: "Réclamations", withdrawal: "Droit de rétractation" },
  },
  es: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "La banda tiene",
    heroTitle2: "un nuevo estándar.",
    heroDesc: 'Conoce "The Gaffer" – La primera bota de fútbol premium del mundo diseñada específicamente para el entrenador. Comodidad, calidez y autoridad en cada paso.',
    heroCta: "Unirse a la lista de espera",
    blog: "Blog",
    problemLabel: "El Problema",
    problemTitle: "El líder olvidado.",
    problemP1: "Cada pieza de equipamiento en un campo de fútbol está diseñada para el jugador. Las botas. Las espinilleras. Las capas base. Todo diseñado para alguien que corre 10 km por partido.",
    problemP2: "¿El entrenador? De pie. Bajo la lluvia. Durante 90 minutos. Con calzado que nunca fue diseñado para la banda.",
    problemP3: 'Es hora de que alguien recuerde al entrenador. Ese alguien somos nosotros. Bienvenido a "The Gaffer."',
    solutionLabel: "La Solución",
    solutionTitle: "El sándwich de materiales.",
    solutionDesc: 'Cada capa de "The Gaffer" cumple un propósito. Nada decorativo. Nada desperdiciado.',
    feat1Title: "Piel de becerro",
    feat1Desc: "Piel de becerro premium que se adapta a tu pie con el tiempo. Envejece bellamente. Hecha para durar temporadas, no partidos.",
    feat2Title: "Membrana TEX",
    feat2Desc: "Repelente al agua. No más pies mojados, ni siquiera bajo la lluvia más intensa.",
    feat3Title: "Warm Lining",
    feat3Desc: "Regulación térmica y confort antibacteriano. Cálida en invierno, fresca en verano.",
    feat4Title: "Suela ergonómica",
    feat4Desc: "Drop talón-punta optimizado para estar de pie, no para esprintar. Comodidad todo el día en la banda.",
    qualityLabel: "Calidad y procedencia",
    qualityTitle: "Hecho a mano en Portugal.",
    qualityP1: '"The Gaffer" se ensambla a mano en una fábrica familiar en el norte de Portugal — una región con más de un siglo de tradición zapatera.',
    qualityP2: "Cada par es cortado, cosido y terminado por artesanos que entienden que una gran bota no se fabrica — se crea.",
    qualityBadge: "Hecho a mano en Portugal",
    footerTitle: "No te pierdas el saque inicial.",
    footerDesc: "Regístrate para ser el primero en saber cuándo comenzamos el softlaunch prepago este otoño. Plazas early-bird limitadas.",
    footerFname: "Nombre",
    footerEmail: "Correo electrónico *",
    footerCta: "Reservar mi par",
    footerSubmitting: "Registrando...",
    footerSuccessTitle: "¡Estás en la lista!",
    footerSuccessDesc: "Te notificaremos cuando lancemos. Revisa tu bandeja de entrada para una confirmación.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Dinamarca · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "Términos y condiciones", privacy: "Política de privacidad", accessibility: "Accesibilidad", complaints: "Reclamaciones", withdrawal: "Desistimiento" },
  },
  it: {
    heroSubtitle: "Engineering for the Sideline",
    heroTitle1: "La linea laterale ha",
    heroTitle2: "un nuovo standard.",
    heroDesc: 'Scopri "The Gaffer" – Il primo scarpone da calcio premium al mondo progettato specificamente per l\'allenatore. Comfort, calore e autorità in ogni passo.',
    heroCta: "Iscriviti alla lista d'attesa",
    blog: "Blog",
    problemLabel: "Il Problema",
    problemTitle: "Il leader dimenticato.",
    problemP1: "Ogni pezzo di equipaggiamento su un campo da calcio è progettato per il giocatore. Gli scarpini. I parastinchi. I sottovestiti. Tutto progettato per qualcuno che percorre 10 km a partita.",
    problemP2: "L'allenatore? Fermo. Sotto la pioggia. Per 90 minuti. Con calzature che non sono mai state progettate per la linea laterale.",
    problemP3: 'È ora che qualcuno pensi all\'allenatore. Quel qualcuno siamo noi. Benvenuto a "The Gaffer."',
    solutionLabel: "La Soluzione",
    solutionTitle: "Il sandwich di materiali.",
    solutionDesc: 'Ogni strato di "The Gaffer" serve a uno scopo. Niente di decorativo. Niente di sprecato.',
    feat1Title: "Pelle di vitello",
    feat1Desc: "Pelle di vitello premium che si adatta al tuo piede nel tempo. Invecchia splendidamente. Costruita per durare stagioni, non partite.",
    feat2Title: "Membrana TEX",
    feat2Desc: "Idrorepellente. Mai più piedi bagnati, anche sotto gli acquazzoni più forti.",
    feat3Title: "Warm Lining",
    feat3Desc: "Regolazione termica e comfort antibatterico. Calda d'inverno, fresca d'estate.",
    feat4Title: "Suola ergonomica",
    feat4Desc: "Drop tacco-punta ottimizzato per stare in piedi, non per lo sprint. Comfort tutto il giorno sulla linea laterale.",
    qualityLabel: "Qualità & provenienza",
    qualityTitle: "Fatto a mano in Portogallo.",
    qualityP1: '"The Gaffer" viene assemblato a mano in una fabbrica a conduzione familiare nel nord del Portogallo — una regione con oltre un secolo di tradizione calzaturiera.',
    qualityP2: "Ogni paio viene tagliato, cucito e rifinito da artigiani che capiscono che un grande scarpone non viene fabbricato — viene creato.",
    qualityBadge: "Fatto a mano in Portogallo",
    footerTitle: "Non perdere il calcio d'inizio.",
    footerDesc: "Iscriviti per essere il primo a sapere quando lanceremo il softlaunch prepagato questo autunno. Posti early-bird limitati.",
    footerFname: "Nome",
    footerEmail: "Indirizzo email *",
    footerCta: "Prenota il mio paio",
    footerSubmitting: "Registrazione...",
    footerSuccessTitle: "Sei nella lista!",
    footerSuccessDesc: "Ti avviseremo al lancio. Controlla la tua posta per una conferma.",
    footerCompany: "Gaffer Athletics ApS · 8870 Langå, Danimarca · CVR: 46469550",
    footerEmailAddr: "Email: contact@gafferathletics.com",
    footerCopyright: "© 2026 Gaffer Athletics. Engineering for the Sideline.",
    footerLinks: { terms: "Termini e condizioni", privacy: "Privacy", accessibility: "Accessibilità", complaints: "Reclami", withdrawal: "Diritto di recesso" },
  },
};

// Cookie Banner translations
export const cookieT = {
  en: { text: "We use cookies to improve your experience. By continuing to browse, you accept our", link: "Privacy & Cookie Policy", accept: "Accept", decline: "Decline" },
  da: { text: "Vi bruger cookies for at forbedre din oplevelse. Ved at fortsætte accepterer du vores", link: "Privatlivs- og cookiepolitik", accept: "Accepter", decline: "Afvis" },
  sv: { text: "Vi använder cookies för att förbättra din upplevelse. Genom att fortsätta accepterar du vår", link: "Integritets- och cookiepolicy", accept: "Acceptera", decline: "Avvisa" },
  no: { text: "Vi bruker informasjonskapsler for å forbedre opplevelsen din. Ved å fortsette godtar du vår", link: "Personvern- og informasjonskapselpolicy", accept: "Godta", decline: "Avslå" },
  de: { text: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Durch Weiternutzung akzeptieren Sie unsere", link: "Datenschutz- und Cookie-Richtlinie", accept: "Akzeptieren", decline: "Ablehnen" },
  fr: { text: "Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre", link: "Politique de confidentialité et cookies", accept: "Accepter", decline: "Refuser" },
  es: { text: "Usamos cookies para mejorar tu experiencia. Al continuar, aceptas nuestra", link: "Política de privacidad y cookies", accept: "Aceptar", decline: "Rechazar" },
  it: { text: "Utilizziamo i cookie per migliorare la tua esperienza. Continuando, accetti la nostra", link: "Politica sulla privacy e i cookie", accept: "Accetta", decline: "Rifiuta" },
};

// Shop translations
export const shopT = {
  en: {
    preOrder: "Pre-Order",
    title: "The Gaffer",
    subtitle: "Premium Football Boot for Coaches",
    desc: "Engineered for the sideline. TEX-membrane waterproofing, warm lining, premium calf leather. Handcrafted in Portugal.",
    size: "Select Size",
    sizeGuide: "Size Guide",
    currency: "Currency",
    shipping: "Shipping",
    shippingDK: "Denmark",
    shippingEU: "Europe",
    shippingINTL: "International",
    features: "Features",
    featLeather: "Calf-Leather",
    featTex: "TEX-Membrane",
    featLining: "Warm Lining",
    featSole: "Ergonomic Sole",
    featPortugal: "Handcrafted in Portugal",
    addToCart: "Continue to Checkout",
    yourDetails: "Your Details",
    name: "Full Name",
    email: "Email",
    address: "Address",
    city: "City",
    postalCode: "Postal Code",
    country: "Country",
    placeOrder: "Place Pre-Order",
    processing: "Processing...",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    shippingCost: "Shipping",
    total: "Total",
    back: "Back to Home",
  },
  da: {
    preOrder: "Forudbestil",
    title: "The Gaffer",
    subtitle: "Premium fodboldstøvle til trænere",
    desc: "Designet til sidelinjen. TEX-membran vandafvisning, warm lining, premium kalvelæder. Håndlavet i Portugal.",
    size: "Vælg størrelse",
    sizeGuide: "Størrelsesguide",
    currency: "Valuta",
    shipping: "Fragt",
    shippingDK: "Danmark",
    shippingEU: "Europa",
    shippingINTL: "International",
    features: "Egenskaber",
    featLeather: "Kalvelæder",
    featTex: "TEX-Membran",
    featLining: "Warm Lining",
    featSole: "Ergonomisk sål",
    featPortugal: "Håndlavet i Portugal",
    addToCart: "Fortsæt til betaling",
    yourDetails: "Dine oplysninger",
    name: "Fulde navn",
    email: "Email",
    address: "Adresse",
    city: "By",
    postalCode: "Postnummer",
    country: "Land",
    placeOrder: "Forudbestil nu",
    processing: "Behandler...",
    orderSummary: "Ordreoversigt",
    subtotal: "Subtotal",
    shippingCost: "Fragt",
    total: "Total",
    back: "Tilbage til forsiden",
  },
  sv: {
    preOrder: "Förbeställ", title: "The Gaffer", subtitle: "Premium fotbollssko för tränare",
    desc: "Designad för sidlinjen. TEX-membran vattenavvisning, warm lining, premium kalvläder. Handgjord i Portugal.",
    size: "Välj storlek", sizeGuide: "Storleksguide", currency: "Valuta", shipping: "Frakt",
    shippingDK: "Danmark", shippingEU: "Europa", shippingINTL: "Internationellt",
    features: "Egenskaper", featLeather: "Kalvläder", featTex: "TEX-Membran", featLining: "Warm Lining", featSole: "Ergonomisk sula", featPortugal: "Handgjord i Portugal",
    addToCart: "Fortsätt till kassan", yourDetails: "Dina uppgifter", name: "Fullständigt namn", email: "E-post", address: "Adress", city: "Stad", postalCode: "Postnummer", country: "Land",
    placeOrder: "Förbeställ nu", processing: "Bearbetar...", orderSummary: "Orderöversikt", subtotal: "Delsumma", shippingCost: "Frakt", total: "Totalt", back: "Tillbaka till startsidan",
  },
  no: {
    preOrder: "Forhåndsbestill", title: "The Gaffer", subtitle: "Premium fotballstøvel for trenere",
    desc: "Designet for sidelinjen. TEX-membran vannavvisning, warm lining, premium kalveskinn. Håndlaget i Portugal.",
    size: "Velg størrelse", sizeGuide: "Størrelsesguide", currency: "Valuta", shipping: "Frakt",
    shippingDK: "Danmark", shippingEU: "Europa", shippingINTL: "Internasjonalt",
    features: "Egenskaper", featLeather: "Kalveskinn", featTex: "TEX-Membran", featLining: "Warm Lining", featSole: "Ergonomisk såle", featPortugal: "Håndlaget i Portugal",
    addToCart: "Fortsett til kassen", yourDetails: "Dine opplysninger", name: "Fullt navn", email: "E-post", address: "Adresse", city: "By", postalCode: "Postnummer", country: "Land",
    placeOrder: "Forhåndsbestill nå", processing: "Behandler...", orderSummary: "Ordreoversikt", subtotal: "Delsum", shippingCost: "Frakt", total: "Totalt", back: "Tilbake til forsiden",
  },
  de: {
    preOrder: "Vorbestellen", title: "The Gaffer", subtitle: "Premium-Fußballschuh für Trainer",
    desc: "Für die Seitenlinie entwickelt. TEX-Membran wasserabweisend, Warm Lining, Premium-Kalbsleder. Handgefertigt in Portugal.",
    size: "Größe wählen", sizeGuide: "Größentabelle", currency: "Währung", shipping: "Versand",
    shippingDK: "Dänemark", shippingEU: "Europa", shippingINTL: "International",
    features: "Eigenschaften", featLeather: "Kalbsleder", featTex: "TEX-Membran", featLining: "Warm Lining", featSole: "Ergonomische Sohle", featPortugal: "Handgefertigt in Portugal",
    addToCart: "Weiter zur Kasse", yourDetails: "Ihre Daten", name: "Vollständiger Name", email: "E-Mail", address: "Adresse", city: "Stadt", postalCode: "Postleitzahl", country: "Land",
    placeOrder: "Jetzt vorbestellen", processing: "Wird verarbeitet...", orderSummary: "Bestellübersicht", subtotal: "Zwischensumme", shippingCost: "Versand", total: "Gesamt", back: "Zurück zur Startseite",
  },
  fr: {
    preOrder: "Précommander", title: "The Gaffer", subtitle: "Chaussure de football premium pour entraîneurs",
    desc: "Conçu pour la ligne de touche. Membrane TEX déperlante, Warm Lining, cuir de veau premium. Fabriqué à la main au Portugal.",
    size: "Choisir la taille", sizeGuide: "Guide des tailles", currency: "Devise", shipping: "Livraison",
    shippingDK: "Danemark", shippingEU: "Europe", shippingINTL: "International",
    features: "Caractéristiques", featLeather: "Cuir de veau", featTex: "Membrane TEX", featLining: "Warm Lining", featSole: "Semelle ergonomique", featPortugal: "Fabriqué à la main au Portugal",
    addToCart: "Continuer vers le paiement", yourDetails: "Vos coordonnées", name: "Nom complet", email: "Email", address: "Adresse", city: "Ville", postalCode: "Code postal", country: "Pays",
    placeOrder: "Précommander maintenant", processing: "Traitement...", orderSummary: "Récapitulatif", subtotal: "Sous-total", shippingCost: "Livraison", total: "Total", back: "Retour à l'accueil",
  },
  es: {
    preOrder: "Reservar", title: "The Gaffer", subtitle: "Bota de fútbol premium para entrenadores",
    desc: "Diseñada para la banda. Membrana TEX repelente al agua, Warm Lining, piel de becerro premium. Hecha a mano en Portugal.",
    size: "Seleccionar talla", sizeGuide: "Guía de tallas", currency: "Moneda", shipping: "Envío",
    shippingDK: "Dinamarca", shippingEU: "Europa", shippingINTL: "Internacional",
    features: "Características", featLeather: "Piel de becerro", featTex: "Membrana TEX", featLining: "Warm Lining", featSole: "Suela ergonómica", featPortugal: "Hecho a mano en Portugal",
    addToCart: "Continuar al pago", yourDetails: "Tus datos", name: "Nombre completo", email: "Email", address: "Dirección", city: "Ciudad", postalCode: "Código postal", country: "País",
    placeOrder: "Reservar ahora", processing: "Procesando...", orderSummary: "Resumen del pedido", subtotal: "Subtotal", shippingCost: "Envío", total: "Total", back: "Volver al inicio",
  },
  it: {
    preOrder: "Prenota", title: "The Gaffer", subtitle: "Scarpa da calcio premium per allenatori",
    desc: "Progettata per la linea laterale. Membrana TEX idrorepellente, Warm Lining, pelle di vitello premium. Fatta a mano in Portogallo.",
    size: "Seleziona taglia", sizeGuide: "Guida alle taglie", currency: "Valuta", shipping: "Spedizione",
    shippingDK: "Danimarca", shippingEU: "Europa", shippingINTL: "Internazionale",
    features: "Caratteristiche", featLeather: "Pelle di vitello", featTex: "Membrana TEX", featLining: "Warm Lining", featSole: "Suola ergonomica", featPortugal: "Fatta a mano in Portogallo",
    addToCart: "Procedi al pagamento", yourDetails: "I tuoi dati", name: "Nome completo", email: "Email", address: "Indirizzo", city: "Città", postalCode: "Codice postale", country: "Paese",
    placeOrder: "Prenota ora", processing: "Elaborazione...", orderSummary: "Riepilogo ordine", subtotal: "Subtotale", shippingCost: "Spedizione", total: "Totale", back: "Torna alla home",
  },
};

// Blog translations (list page)
export const blogListT = {
  en: { title: "The Gaffer Blog", subtitle: "Insights on sideline footwear, coaching comfort, and the craft behind The Gaffer.", readMore: "Read Article", minRead: "min read", backHome: "Back to Home" },
  da: { title: "The Gaffer Blog", subtitle: "Indsigt om fodtøj til sidelinjen, trænerkomfort og håndværket bag The Gaffer.", readMore: "Læs artikel", minRead: "min læsning", backHome: "Tilbage til forsiden" },
  sv: { title: "The Gaffer Blogg", subtitle: "Insikter om sidlinjens skor, tränarkomfort och hantverket bakom The Gaffer.", readMore: "Läs artikel", minRead: "min läsning", backHome: "Tillbaka till startsidan" },
  no: { title: "The Gaffer Blogg", subtitle: "Innsikt om fottøy for sidelinjen, trenerkomfort og håndverket bak The Gaffer.", readMore: "Les artikkel", minRead: "min lesing", backHome: "Tilbake til forsiden" },
  de: { title: "Der Gaffer Blog", subtitle: "Einblicke in Seitenlinien-Schuhe, Trainerkomfort und das Handwerk hinter The Gaffer.", readMore: "Artikel lesen", minRead: "Min. Lesezeit", backHome: "Zurück zur Startseite" },
  fr: { title: "Le Blog Gaffer", subtitle: "Perspectives sur les chaussures de bord de terrain, le confort des entraîneurs et le savoir-faire derrière The Gaffer.", readMore: "Lire l'article", minRead: "min de lecture", backHome: "Retour à l'accueil" },
  es: { title: "El Blog Gaffer", subtitle: "Perspectivas sobre el calzado de banda, comodidad del entrenador y el oficio detrás de The Gaffer.", readMore: "Leer artículo", minRead: "min de lectura", backHome: "Volver al inicio" },
  it: { title: "Il Blog Gaffer", subtitle: "Approfondimenti sulle calzature da bordo campo, il comfort dell'allenatore e l'artigianato dietro The Gaffer.", readMore: "Leggi articolo", minRead: "min di lettura", backHome: "Torna alla home" },
};

// Blog CTA translations
export const blogCtaT = {
  en: { title: "Join the Waitlist", desc: "Be the first to know when we start the prepaid softlaunch.", cta: "Sign Up Now" },
  da: { title: "Tilmeld ventelisten", desc: "Vær den første til at vide, når vi starter det forudbetalte softlaunch.", cta: "Tilmeld dig nu" },
  sv: { title: "Gå med i väntelistan", desc: "Var först med att veta när vi startar den förbetalda softlanseringen.", cta: "Registrera dig nu" },
  no: { title: "Bli med på ventelisten", desc: "Vær den første til å vite når vi starter den forhåndsbetalte softlanseringen.", cta: "Meld deg på nå" },
  de: { title: "Auf die Warteliste", desc: "Erfahren Sie als Erster vom vorausbezahlten Softlaunch.", cta: "Jetzt anmelden" },
  fr: { title: "Rejoindre la liste d'attente", desc: "Soyez le premier informé du softlaunch prépayé.", cta: "S'inscrire maintenant" },
  es: { title: "Únete a la lista de espera", desc: "Sé el primero en saber del softlaunch prepago.", cta: "Regístrate ahora" },
  it: { title: "Iscriviti alla lista d'attesa", desc: "Sii il primo a sapere del softlaunch prepagato.", cta: "Iscriviti ora" },
};

// Success page
export const successT = {
  en: { title: "Order Confirmed!", subtitle: "Thank you for your pre-order.", orderNum: "Order Number", product: "Product", size: "Size", total: "Total", status: "Status", paid: "Paid", email: "Confirmation sent to", home: "Back to Home", loading: "Confirming your order...", error: "Could not retrieve order details.", tryAgain: "Try Again" },
  da: { title: "Ordre bekræftet!", subtitle: "Tak for din forudbestilling.", orderNum: "Ordrenummer", product: "Produkt", size: "Størrelse", total: "Total", status: "Status", paid: "Betalt", email: "Bekræftelse sendt til", home: "Tilbage til forsiden", loading: "Bekræfter din ordre...", error: "Kunne ikke hente ordredetaljer.", tryAgain: "Prøv igen" },
  sv: { title: "Order bekräftad!", subtitle: "Tack för din förbeställning.", orderNum: "Ordernummer", product: "Produkt", size: "Storlek", total: "Totalt", status: "Status", paid: "Betald", email: "Bekräftelse skickad till", home: "Tillbaka till startsidan", loading: "Bekräftar din order...", error: "Kunde inte hämta orderdetaljer.", tryAgain: "Försök igen" },
  no: { title: "Ordre bekreftet!", subtitle: "Takk for din forhåndsbestilling.", orderNum: "Ordrenummer", product: "Produkt", size: "Størrelse", total: "Totalt", status: "Status", paid: "Betalt", email: "Bekreftelse sendt til", home: "Tilbake til forsiden", loading: "Bekrefter din ordre...", error: "Kunne ikke hente ordredetaljer.", tryAgain: "Prøv igjen" },
  de: { title: "Bestellung bestätigt!", subtitle: "Vielen Dank für Ihre Vorbestellung.", orderNum: "Bestellnummer", product: "Produkt", size: "Größe", total: "Gesamt", status: "Status", paid: "Bezahlt", email: "Bestätigung gesendet an", home: "Zurück zur Startseite", loading: "Ihre Bestellung wird bestätigt...", error: "Bestelldetails konnten nicht abgerufen werden.", tryAgain: "Erneut versuchen" },
  fr: { title: "Commande confirmée !", subtitle: "Merci pour votre précommande.", orderNum: "Numéro de commande", product: "Produit", size: "Taille", total: "Total", status: "Statut", paid: "Payé", email: "Confirmation envoyée à", home: "Retour à l'accueil", loading: "Confirmation de votre commande...", error: "Impossible de récupérer les détails de la commande.", tryAgain: "Réessayer" },
  es: { title: "¡Pedido confirmado!", subtitle: "Gracias por tu reserva.", orderNum: "Número de pedido", product: "Producto", size: "Talla", total: "Total", status: "Estado", paid: "Pagado", email: "Confirmación enviada a", home: "Volver al inicio", loading: "Confirmando tu pedido...", error: "No se pudieron obtener los detalles del pedido.", tryAgain: "Intentar de nuevo" },
  it: { title: "Ordine confermato!", subtitle: "Grazie per il tuo preordine.", orderNum: "Numero ordine", product: "Prodotto", size: "Taglia", total: "Totale", status: "Stato", paid: "Pagato", email: "Conferma inviata a", home: "Torna alla home", loading: "Conferma del tuo ordine...", error: "Impossibile recuperare i dettagli dell'ordine.", tryAgain: "Riprova" },
};
